module.exports = __webpack_public_path__ + "media/images/fuda00-26f400640260abf8936e6e235a4c1523.jpg";